export default __webpack_public_path__ + "static/char-42-anr-632006a0d2d74067b6c0dc71d3d16916.webp";